/**
 * Updates locationCreateData in the `little-state-machine` store.
 * Appends @form-data to existing store.
 */
export default function updateLocationCreateAction(state, formData) {
  return ({
    ...state,
    locationCreateData: {
      ...state.locationCreateData,
      ...formData,
    },
  });
}
